import { isCheckoutOffer, isCheckoutRegular } from "./checkoutType";

const StepEnum = {
  MODULE: "module",
  PERSONAL: "personal",
  SUMMARY: "summary",
  QUOTE_PERSONAL: "quotePersonal",
  QUOTE_SUMMARY: "quoteSummary",
};

function getCurrentStepEnum(
  currentStep,
  isModuleSchedulerActive,
  checkoutType
) {
  if (isCheckoutRegular(checkoutType)) {
    if (isModuleSchedulerActive) {
      switch (currentStep) {
        case 0:
          return StepEnum.MODULE;
        case 1:
          return StepEnum.PERSONAL;
        case 2:
          return StepEnum.SUMMARY;
      }
    }

    switch (currentStep) {
      case 0:
        return StepEnum.PERSONAL;
      case 1:
        return StepEnum.SUMMARY;
    }
  }

  if (isCheckoutOffer(checkoutType)) {
    switch (currentStep) {
      case 0:
        return StepEnum.QUOTE_PERSONAL;
      case 1:
        return StepEnum.QUOTE_SUMMARY;
    }
  }

  return null;
}

function isStepModuleActive(currentStepEnum) {
  return currentStepEnum === StepEnum.MODULE;
}

function isStepPersonalActive(currentStepEnum) {
  return (
    currentStepEnum === StepEnum.PERSONAL ||
    currentStepEnum === StepEnum.QUOTE_PERSONAL
  );
}

function isStepSummaryActive(currentStepEnum) {
  return (
    currentStepEnum === StepEnum.SUMMARY ||
    currentStepEnum === StepEnum.QUOTE_SUMMARY
  );
}

export {
  StepEnum,
  getCurrentStepEnum,
  isStepModuleActive,
  isStepPersonalActive,
  isStepSummaryActive,
};
